import { Component, OnInit } from '@angular/core'
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { MessageService } from 'primeng/api'
import { SecurityQuestions } from '../../../api/models/security-questions'
import { SecurityQuestionService } from '../../../api/services'
import { SecurityAnswersService } from '../../../api/services/security-answers.service'
import { CareFinitySession } from '../../services/CareFinitySession'
import { environment } from '../../../../environments/environment'

@Component({
  selector: 'app-question-answer',
  templateUrl: './question-answer.component.html',
  styleUrls: ['./question-answer.component.css'],
})
export class QuestionAnswerComponent implements OnInit {
  questions: SecurityQuestions[]
  questionForm: UntypedFormGroup
  questionsArray: UntypedFormArray

  public displaypopup: boolean = false
  public title: string = 'Security Questions'
  version: string = '0.0.0';
  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private questionService: SecurityQuestionService,
    private questionAnswerService: SecurityAnswersService,
  ) {}

  getFormAsArray() {
    return this.questionForm.get('questionFormArray') as UntypedFormArray
  }
  ngOnInit() {
      this.displaypopup = true
      this.version = environment.version;

    this.route.data.subscribe(
      (val) => {
        if (val['question_list']) {
          this.questions = val['question_list'].data
        }
      },
      (err) => {
        console.error(err)
        //this.messageService.add({
        //    severity: 'error',
        //    summary: 'Something went wrong',
        //    detail: `Couldn't fetch question list`
        //});
        this.messageService.add({
          key: 'alertToast',
          severity: 'error',
          detail: `Couldn't fetch question list`,
            summary: 'ERROR',
          life: 7000,
        })
      },
    )

    this.questionForm = this.fb.group({
      questionFormArray: this.fb.array([]),
    })
    this.questionsArray = this.questionForm.get(
      'questionFormArray',
    ) as UntypedFormArray
    this.questions.forEach((question) => {
      this.questionsArray.push(this.createQuesionGroup(question))
    })
  }

  onSubmitForm(): void {
    const formValue = this.questionForm.getRawValue()
      .questionFormArray as Array<any>
    const filteredFormValue = formValue
      .filter((value) => value.isSelected && value.answer.length > 0)
      .map((val) => ({
        questionId: val.questionId,
        answerDescription: val.answer,
      }))
    this.messageService.clear()
    if (filteredFormValue.length < 3 && formValue.length > 3) {
      const summary = 'Answer atleast 3 questions'
      const detail = 'You need to answer atleast 3 questions'
      this.displayErrorMessage(summary, detail)
    } else if (
      formValue.length <= 3 &&
      filteredFormValue.length !== formValue.length
    ) {
      const summary = 'Answer all questions'
      const detail = 'You need to answer all the questions'
      this.displayErrorMessage(summary, detail)
    } else {
      // call save api with filtered Form Value and display message
      console.log('Value ', filteredFormValue)
      this.questionAnswerService
        .securityAnswersPost$Response({
          body: {
            securityAnswers: filteredFormValue,
          },
        })
        .subscribe(
          (i) => {
            this.messageService.add({
              key: 'alertToast',
              severity: 'success',
              detail: `Saved Successfully`,
              summary: 'Saved Successfully',
              life: 7000,
            })

            //this means user is logging in first time
            if (CareFinitySession.user.forcePasswordChange) {
              const authorization = i.headers.get('Authorization')
              this.router.navigate(['force-reset-password'], {
                state: { key: authorization },
                queryParams: { u_Name: CareFinitySession.user.userName },
              })
              return
            }
            CareFinitySession.user.mfaDone = true
            CareFinitySession.user.forcePasswordChange = false
            this.router.navigate(['select-practice'])
          },
          (err) => {
            console.error(err)
            this.messageService.add({
              key: 'alertToast',
              severity: 'error',
              detail: `something went wrong in saving`,
              summary: 'Error in saving questions',
              life: 7000,
            })
          },
        )
    }
  }

  private displayErrorMessage(summary: string, detail: string): void {
    this.messageService.add({
      key: 'alertToast',
      severity: 'error',
      detail: detail,
      summary: summary,
      life: 7000,
    })
  }

  private createQuesionGroup(question: SecurityQuestions): UntypedFormGroup {
    return this.fb.group({
      questionDesciption: [question.description],
      questionId: [question.questionId],
      isSelected: [false],
      answer: [''],
    })
  }
}
